import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { RefundStatus } from '../enums/refund-status';

@Injectable({
  providedIn: 'root',
})
export class RefundStatusProviderService {
  private readonly entries = new Map<RefundStatus, string>([
    [RefundStatus.Cancelled, 'Anulowany'],
    [RefundStatus.Finalized, 'Przetworzony'],
    [RefundStatus.Processed, 'W trakcie procesowania'],
  ]);

  public labelFor(status: RefundStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<RefundStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<RefundStatus>(label, type),
      ),
    );
  }
}
